<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 35%; min-width: 500px;">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">Add Reference Prescribers</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style='padding: 0'></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <form class="action-modal" @submit.prevent>
                            <div class="form-section-container" style="grid-template-columns: 1fr">
                                <div class="right-form-section-panel">
                                    <p v-if="!error" style="font-size: 1em;">Before proceeding, please make sure to properly check that prescriber does not come up in the search prescriber list via their name or prescriber number.</p>
                                    <p v-else style="font-size: 1em;">{{ error }}</p>
                                    <template v-if="!loading">
                                        <div class="right-form-section-drug-entry" v-for="(row, index) in rows" :key="index"
                                            style="display: flex; align-items: center; margin-bottom: 8px;">
                                            <input v-model="row.first_name" placeholder="Enter first name"
                                                style="position: relative; width: 50%; margin-right: 10px" />
                                            <input v-model="row.last_name" placeholder="Enter last name"
                                                style="position: relative; width: 50%;" />
                                            <button class="red-close-button" type="button" style="margin-left: 10px;"
                                                v-if="rows.length > 1" @click="removeRow(index)">
                                                <i class="pi pi-times" style='padding: 0'></i>
                                            </button>
                                            <span v-else style="width: 42px;"></span>
                                        </div>
                                        <p class="blue-button" style="width: fit-content; margin: 10px 0 0; font-size: 1em;"
                                            v-if="rows.length < maxRows" @click="addRow()">+ Add another</p>
                                        <p v-else style="font-size: 0.9em; margin: 10px 0 0; color: grey;">
                                            {{ maxRows }} prescribers is the most that can be added at once.
                                        </p>
                                    </template>
                                    <div v-else style="display: flex; align-items: center; justify-content: center;">
                                        <span>Adding reference prescribers...</span>
                                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem !important;"></i>
                                    </div>
                                </div>
                            </div>
                        </form>

                    </slot>
                </div>

                <p style="color: red;" v-if="errorMessage">{{ errorMessage }}</p>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex;">
                        <p class="regular-button" style="color: white; margin-right: 10px;" @click="closeModal">Cancel
                        </p>
                        <p class="regular-button complete-button" style="background-color: green" v-if="!loading"
                            @click="addReferencePrescribers()">{{ submitLabel }}</p>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    components: {
    },
    data() {
        return {
            errorMessage: '',
            error: null,
            loading: false,
            // Matches the max on the backend's prescribers array rule.
            maxRows: 25,
            rows: [
                {
                    first_name: '',
                    last_name: '',
                    // regulatory_numbers:[
                    //         {
                    //             data:'',
                    //             regulatory_type:'Prescriber Number',
                    //             expiry:''
                    //         }
                    // ]
                }
            ]
        }
    },
    computed: {
        // Blank trailing rows are ignored on submit, so the count reflects what
        // will actually be created rather than how many inputs are on screen.
        filledRows() {
            return this.rows.filter(row => row.first_name.trim() != '' || row.last_name.trim() != '');
        },
        submitLabel() {
            return this.filledRows.length > 1
                ? `Add ${this.filledRows.length} Reference Prescribers`
                : 'Add Reference Prescriber';
        }
    },
    methods: {

        isSuccessful(value) {
            if (value) {
                this.$emit('close', true);
            }
        },
        addRow() {
            if (this.rows.length < this.maxRows) {
                this.rows.push({ first_name: '', last_name: '' });
            }
        },
        removeRow(index) {
            if (this.rows.length > 1) {
                this.rows.splice(index, 1);
            }
        },
        addReferencePrescribers() {
            const prescribers = this.filledRows.map(row => {
                return {
                    first_name: row.first_name.trim(),
                    last_name: row.last_name.trim()
                }
            });

            if (prescribers.length == 0) {
                this.errorMessage = 'Please provide both names for the reference prescriber.';
                return;
            }

            if (prescribers.some(row => row.first_name == '' || row.last_name == '')) {
                this.errorMessage = 'Please provide both names for every reference prescriber.';
                return;
            }

            this.errorMessage = '';
            this.loading = true;
            axios.post(`/person/create/reference-prescriber`, { prescribers: prescribers }, this.$store.state.header).then(res => {
                const created = res.data || [];
                this.loading = false;
                // The parent modals each hold a single prescriber on the form
                // that opened this one, so they take the first created record.
                if (created.length > 0) {
                    this.$emit('prescriber', created[0]);
                }
                this.$emit('prescribers', created);
            }).catch(err => {
                console.log('this is th err', err);
                this.loading = false;
                this.error = (err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message
                    : (err.response ? err.response.data : 'The reference prescribers could not be added.');
            })
        },
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close', true);
        }
    },
    mounted() {
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";
</style>
